import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const EngineMono = {
  id: "20",
  name: "Motor",
  mainClass: "Rotativos",
  subtype: "Monofásico",
  variables: [],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.voltage,
      unit: unitDefault.voltage.metric,
      code: "engineVoltage"
    },
    {
      value: 0,
      type: unitTypes.power,
      unit: unitDefault.power.metric,
      code: "enginePower"
    },
    {
      value: 0,
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "engineEfficiency"
    },
    {
      value: "Generator",
      type: "unique",
      unit: "",
      code: "engineDriven"
    },
    {
      value: 0,
      type: unitTypes.frequency,
      unit: unitDefault.frequency.metric,
      code: "engineFrequency"
    },
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "engineSpeed"
    },
    {
      value: 0.7,
      type: "unique",
      unit: "",
      code: "enginePowerFactor"
    }
  ]
};
